module.exports = __webpack_public_path__ + "static/media/halo1.c9814ebb.svg";